export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'dianying',
    name: '电影',
    description: '最新最热的电影推荐，涵盖动作、喜剧、爱情、科幻等多种类型',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    description: '热门电视剧大全，国产剧、韩剧、美剧、日剧一网打尽',
    icon: 'ri-tv-2-line',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '热门综艺节目推荐，搞笑、音乐、竞技、旅行各类综艺',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '日本动漫、国产动漫、欧美动漫最新番剧推荐',
    icon: 'ri-ghost-line',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '自然、历史、科技、人文等各类高分纪录片推荐',
    icon: 'ri-earth-line',
  },
  {
    slug: 'duanju',
    name: '短剧',
    description: '微短剧、竖屏剧、网络短剧，碎片时间轻松看',
    icon: 'ri-smartphone-line',
  },
];